<template>
  <div
    id="mainPage"
    class="container-fluid"
    style="
      border: 0 solid gray;
      height: 40rem;
      margin: 0.5rem;
      width: 1100px;
      max-width: 1100px;
      min-width: 1100px;
    "
  >
    <div
      class="headerPaneHorizontal"
    >
      <div class="headerBadgesPanel">
        <div class="row">
          <div class="col-6 my-certs">
            <div class="certs-awarded">My Badges & Certificates</div>
            </div>

          <div
            class="col-6"
            id="header_login_box="
            ref="header_login_box"
            style="text-align: right"
          >
            <div class="headerBadgesQuitBox01" style="text-align: left">
              <!-- <router-link class="quit-link-text" to="/">  -->
              <img @click="$emit('close')" class="close-out-icon" :src="require(`../assets/icons/CloseOut.svg`)" alt="Close View">
              <!-- </router-link> -->
            </div>
            <div class="headerBadgesQuitBox02" style="text-align: right">
              <router-link to="/">
              <img class="close-out-icon" :src="require(`../assets/icons/CloseOut.svg`)" alt="Close View">
              </router-link>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 headerSeparator"></div>
        </div>
      </div>
    </div>
    <div class="no-badgesPanel" v-if="totalCompleteBadges < 1">
      You have not earned any badges yet
    </div>

    <div
      class="badgesPanel"
      style="width: 52rem; border: none"
      v-if="totalCompleteBadges > 0"
    >
      <div class="row">
        <div class="badge-area">
          <div v-for="(badgeInfo, idxv) in filteredBadgeList" :key="`${idxv}`">
            <div class="row accordionLevel01">
              <div class="badge-emblem" style="text-align: left">
                <img
                  class="cert-page-badge"
                  style="height: 3rem"
                  :src="require('../assets/' + getBadgePathColor(badgeInfo))"
                />
              </div>
               <!-- <div class="col-5 badgeNameBox">
                                    <div class="faName">
                                      {{ faInfo.funcAreaTitle }}
                                    </div> -->
                                    <div class="badge-info-area">
                                      <div class="temp-text">{{ badgeInfo.funcAreaTitle}}</div>
                                      <div class="badge-name">
                                        {{ badgeInfo.badgeName }}
                                      </div>
                                      <div class="badgeDate">
                                      {{
                                        getYearFromTimestamp(
                                          badgeInfo.createdDate
                                        )
                                      }}
                                      Edition
                                      </div>
                                    </div>
              <div
                class="button-and-date"
              >
              <div class="cert-section">
                <button class="certView" @click="genBadge(badgeInfo)" 
                  >View Certificate</button
                >
              </div>
              <div class="issue-date">
                Issue Date: {{ badgeInfo.formattedCompleteDate }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as axios from "axios";
const { jwt_decode, jwt_encode } = require("../jwt.js");

const settings = require("/ps_settings/config.json");

export default {
  name: "BadgesPage",
  data() {
    return {
      envVars: process.env,
      badgePathGray: "badges",
      badgePathColor: "badges",
      totalCompleteBadges: 0,
      store: this.$store,
      progressData: this.$store.progressData,
      filteredBadgeList: [],
    };
  },
  props: {
    msg: String,
  },
  components: {},
  methods: {
    getYearFromTimestamp(timestamp) {
      let date = new Date(timestamp);
      return date.getFullYear();
    },
    getBadgePathColor(badgeInfo) {
      return `${this.badgePathColor}/badge_color_${badgeInfo.badgeKey}.svg`;
    },
    getBadgePathGray(badgeInfo) {
      return `${this.badgePathGray}/badge_gray_${badgeInfo.badgeKey}.svg`;
    },
    getBadgePath(badgeInfo) {
      if (badgeInfo.isBadgeComplete) {
        return this.getBadgePathColor(badgeInfo);
      } else {
        return this.getBadgePathGray(badgeInfo);
      }
    },
    genBadge(badgeInfo) {
      //console.log("the certificate has been requested here =====>>>>>", badgeInfo);
      var firstName = this.$store.firstName;
      var lastName = this.$store.lastName;
      var sis_user_id = this.$store.sis_user_id;
      var cert_credentials = {
        user_name: `${firstName} ${lastName}`,
        sis_user_id: sis_user_id,
        badge_key: badgeInfo.badgeKey,
        issue_date: badgeInfo.completeDate,
        total_cpe_hours: badgeInfo.totalCpeHours,
      };
      //console.log("for this cert, these are the creds.....====>>>>", cert_credentials);
      let certToken = jwt_encode(cert_credentials, false, "1h");
      window.open(
        `${settings.API_HOST}/mycertificate.pdf?token=${certToken}`,
        "_blank"
      );
    },
    currentData() {
      const requestOptions = {
        url: `${settings.API_HOST}/current/${this.sis_user_id}`,
        method: "GET",
        headers: { "Access-Control-Allow-Origin": "*" },
        params: {},
      };
      axios(requestOptions)
        .then((res) => {
          let resultData = res.data;
          let progressData = resultData[this.sis_user_id];
          if (progressData) {
            let totalBadgesComplete = 0;
            this.$store.progressData = progressData;
            this.progressData = this.$store.progressData;
            for (const [faSortKey, faInfo] of Object.entries(
              this.progressData
            )) {
              if (this.currentFuncAreaBadgesShow == faInfo.faKey) {
                faInfo.showBadges = false;
              } else {
                faInfo.showBadges = false;
              }
              for (const [badgeSortKey, badgeInfo] of Object.entries(
                faInfo.progress_badge_sort_dict
              )) {
                if (badgeInfo.isBadgeComplete) {
                  badgeInfo.badgeFile = `badge_color_${badgeInfo.badgeKey}`;
                  totalBadgesComplete = totalBadgesComplete + 1;
                } else {
                  badgeInfo.badgeFile = `badge_gray_${badgeInfo.badgeKey}`;
                }
              }
            }
            this.totalBadgesComplete = totalBadgesComplete;
            this.$store.totalBadgesComplete = totalBadgesComplete;
          }
        })
        .catch((error) => {
          console.log(error);
          // return Promise.reject(error);
        });
    },
    createFilteredBadgeList() {
      let totalCompleteBadges = 0;
      let filteredBadgeList = [];

      for (const [faSortKey, faInfo] of Object.entries(
        this.$store.progressData
      )) {
        for (const badgeInfoList of Object.values(
          faInfo.progress_badge_sort_dict
        )) {
          badgeInfoList.forEach((badgeInfo) => {
            if (badgeInfo.isBadgeComplete) {
              badgeInfo.funcAreaTitle = faInfo.funcAreaTitle;
              filteredBadgeList.push(badgeInfo);
              totalCompleteBadges += 1;
            }
          });
        }
      }
      this.$store.filteredBadgeList = filteredBadgeList;
      this.filteredBadgeList = filteredBadgeList;
      this.totalCompleteBadges = totalCompleteBadges;
    },
  },
  mounted() {
    this.createFilteredBadgeList();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/mainPage.scss";
.certView {
  cursor: pointer;
}

.badgeDate {
  text-align: left;
  font-size: 14px;
  font-family: $selectFontFamily;
  line-height: 14px;
  font-weight: 400;
  padding-bottom: 8px;
}

.badge-info-area {
  display: flex;
  flex-direction: column;
  height: 72px;
  align-self: center;
  margin-top: -20px;
  margin-left: -60px;
}

.badge-name {
  text-align: left;
  padding-top: 13px;
  font-size: 16px;
  font-family: $selectFontFamily;
  line-height: 20px;
  padding-bottom: 2px;
}

.cert-section {
  height: 90px;
  margin-top: -25px;
  padding-top: 8px;
  padding-bottom: 8px;
  margin-left: -36px;
  padding-right: 16px;
}

.button-and-date {
  display: flex;
  flex-direction: column;
  margin-left: 424px;
  margin-top: -57px;
}

.certView {
  cursor: pointer;
  color: #fff;
  background-color: #2472e8;
  border: none;
  text-decoration: none;
  height: 35px;
  line-height: 19px;
  text-align: center;
  width: 164px;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 50px;
  margin-top: 12px;
}

.issue-date {
  font-size: 12px;
  text-align: center;
  margin-top: -33px;
  font-family: $selectFontFamily;
  line-height: 16px;
  margin-left: -50px;
  padding-bottom: 8px;
}

.temp-text {
  margin-top: -3px;
  text-align: left;
  margin-bottom: -14px;
  font-size: 14px;
  line-height: 14px;
  font-weight: 400;
  font-family: $selectFontFamily;
  padding-top: 8px;
  padding-bottom: 4px;
}

.badge-info-area {
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  margin-top: -5px;
}

.badge-area {
  width: 648px;
}

.badge-emblem {
  margin-top: 3px;
  margin-left: -10px;
  padding-left: 16px;
}

.quit-link-text {
  color: #1e1e1e;
  margin-left: 50px;
  display: block;
  // height: 12px;
  // line-height: 12px;
  // font-size: 18px;
}

.close-out-icon {
  height: 12px;
  margin-top: -102px;
  margin-left: 530px;
  cursor: pointer;
}

#mainPage {
  overflow-y: auto;
}

.headerPaneHorizontal {
  position: fixed;
  top: 0;
  background-color: #ffffff;
  z-index: 10;
  margin-top: 150px;
}

.accordionLevel01 {
  margin-left: 20px;
}
</style>

